import { Divider, Paper, Stack, Typography } from '@mui/material';
import type { HomePageTopGrossing } from '@weft/api-definition';
import { HomePageTopCustomersListItem } from './HomePageTopCustomersListItem';

type HomePageTopCustomersSectionProps = {
  topCustomersData: HomePageTopGrossing[]
};

export const HomePageTopCustomersSection: React.FC<HomePageTopCustomersSectionProps> = ({ topCustomersData }) => {
  return (
    <Paper
      variant='outlined' 
      sx={(theme) => ({
        boxShadow: theme.shadows[1],
        paddingTop: 3,
        paddingBottom: 1.5,
      })}
    >
      <Typography
        sx={{
          paddingX: 3,
          paddingBottom: 3,
        }}
        variant='h6'
      >
        Top Customers
      </Typography>
      <Stack
        divider={<Divider
          orientation="horizontal"
          flexItem
                 />}
        gap={1.5}
      >
        {topCustomersData.map((customerData, index) => (
          <HomePageTopCustomersListItem 
            key={crypto.randomUUID()}
            customerData={customerData}
            index={index}
          />
        ))}
      </Stack>

    </Paper>
  );
};